import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Flex } from '@radix-ui/themes';
import { useStackModal } from '@rango-dev/internal-profile/hooks';
import { useTranslation } from 'react-i18next';
import { CONNECT_WALLETS_MODAL_ID, STATEFUL_CONNECT_MODAL_ID } from '../../constants/mod';
import { ProfileWallet } from '../ProfileWallet';
import { ConnectedWalletsEmptyState } from './ConnectedWalletsEmptyState';
export function ConnectedWallets(props) {
    const { accounts, setShouldOpenConnectWalletsModal, data, onLogin, onMerge, onError } = props;
    const { pop, stack } = useStackModal();
    const { t } = useTranslation();
    const connectedAccounts = accounts.filter((account) => account.walletType !== null);
    const handleOpenConnectWalletsModal = () => {
        setShouldOpenConnectWalletsModal?.(!stack.some((item) => item.id === CONNECT_WALLETS_MODAL_ID));
        pop(stack.some((item) => item.id === STATEFUL_CONNECT_MODAL_ID) ? 2 : 1);
    };
    return (_jsxs(Flex, { direction: "column", gap: "4", flexGrow: "1", minHeight: "0", children: [connectedAccounts.length ? (_jsx(Flex, { direction: "column", gap: "3", flexGrow: "1", minHeight: "0", overflowY: "auto", children: accounts.map((account) => {
                    const { walletType, address, blockchain } = account;
                    if (!walletType) {
                        return null;
                    }
                    return (_jsx(ProfileWallet, { account: account, data: data, onLogin: onLogin, onMerge: onMerge, onError: onError }, address + blockchain + walletType));
                }) })) : (_jsx(Flex, { direction: "column", flexGrow: "1", minHeight: "0", children: _jsx(ConnectedWalletsEmptyState, {}) })), _jsx(Box, { width: "100%", flexShrink: "0", asChild: true, children: _jsx(Button, { id: "connect-wallets-button", onClick: handleOpenConnectWalletsModal, variant: "outline", radius: "full", size: { initial: '4', sm: '3' }, children: t('Connect more wallets') }) })] }));
}
